import './App.css';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { createContext, useReducer } from 'react';
import Athlete from './Components/Athlete';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { TBD } from './Components/common';
import Coach from './Components/Coach';
// react router
import { BrowserRouter as Router,Switch,Route,Link } from "react-router-dom";

const ViewsDispatch = createContext();
const DataDispatch = createContext();
const CoachDataDispatch = createContext();

function App() {
  const appState = {
    view: 'home',
  };
  const dataState = {
    first_name: '',
    middle_name: '',
    last_name: '',
    address: '',
    parish: '',
    dob: '',
    nrid: '',
    gender: '',
    country: '',
    nationality: '',
    home: '',
    mobile: '',
    email: '',
    medical: true,
    medical_treatment1 : '',
    medical_treatment2 : '',
    medical_treatment3 : '',
    medical_treatment4 : '',
    medical_treatment5 : '',
    medications1 : '',
    medications2 : '',
    medications3 : '',
    medications4 : '',
    medications5 : '',
    supplements1 : '',
    supplements2 : '',
    supplements3 : '',
    supplements4 : '',
    supplements5 : '',
    schoolID: 'not attached',
    clubID: 'not attached',
    alt_email: '',
    photo_url: '',
    waiver_url: '',
    shirt_size: '',
    pants_size: '',
    shoe_size: '',
    sig_waiver: '',
    sig_antidope: '',
    sig_authorize: '',
    sig_check_waiver: false,
    sig_check_antidope: false,
    sig_check_authorize: false,
    has_error: false,
    submit_error: false,
    error_message: '',
    photo_file : null
  };
  const coachDataState = {
    first_name: '',
    middle_name: '',
    last_name: '',
    address : '',
    parish : '',
    home : '',
    mobile : '',
    email: '',
    clubID: '',
  };
  const [{ view }, viewDispacth] = useReducer(viewReducer, appState);
  function viewReducer(state, action) {
    return { ...state, view: action.value };
  }
  const [_dataState, dataDispacth] = useReducer(dataReducer, dataState);
  function dataReducer(state, action) {
    const { type, value, error_message } = action;
    if(type === 'RESET_STATE'){
      return {...state , ...dataState};
    }
    if(type === 'LOAD_SAVED_STATE'){
      return {...value};
    }
    return { ...state, [type]: value, error_message };
  }
  const [_coachDataState, coachDataDispacth] = useReducer(
    coachDataReducer,
    coachDataState,
  );
  function coachDataReducer(state, action) {
    const { type, value } = action;
    if(type === 'RESET_STATE'){
      return {...state , ...coachDataState};
    }
    return { ...state, [type]: value };
  }
  function Loading() {
    return (
      <div
        style={{ minHeight: 600, width: '100%' }}
        className="d-flex align-items-center justify-content-center"
      >
        <Spinner
          className="mr-1"
          animation="grow"
          size="sm"
          variant="primary"
        />
        <Spinner
          className="mr-1"
          animation="grow"
          size="sm"
          variant="primary"
        />
        <Spinner
          className="mr-1"
          animation="grow"
          size="sm"
          variant="warning"
        />
        <Spinner className="mr-1" animation="grow" size="sm" variant="dark" />
        <Spinner
          className="mr-1"
          animation="grow"
          size="sm"
          variant="warning"
        />
        <Spinner
          className="mr-1"
          animation="grow"
          size="sm"
          variant="primary"
        />
        <Spinner
          className="mr-1"
          animation="grow"
          size="sm"
          variant="primary"
        />
      </div>
    );
  }
  function LandingPage(){
    return(

      <Container fluid style={{ width: '100%' }}>       
        <div style={{ display : "flex" , flexDirection : "column" ,padding:2}}>
          <h4 className="header-text">Welcome</h4>
          <p className="header-text">Welcome to the Athletics Association of Barbados 2020-21 registration portal.</p>
        <div className="border border-bottom" /></div>        
        <div style={{ display : "flex" ,justifyContent : "flex-end" ,alignItems : "center", padding:4 }}>
          <Button className= "signin-button" variant="success" style={{ height: 60, width: 150 }}>
          <a href="https://portal.athleticsassociationbb.com/" style={{color : "white" , textDecoration : "none"}}>Sign In</a>
          </Button> 
        </div>
        <div className= "mobile-logo-header" style={{ display : "flex" ,justifyContent : "space-between" ,alignItems : "center", padding:10}}>
          <img alt="AAB" src="AABLogo.png" className="mobile-logo-header1" style={{marginRight : 8}}/>
          <img alt="AAB" src="pumalogo.png" className="mobile-logo-header2" width={130} style={{marginLeft : 8}}/>
        </div>
         <div className="border border-bottom mobile-logo-header2" />                        
      <div style={{ display : "flex" ,justifyContent : "space-between" ,alignItems : "center"}}>
      <img alt="AAB" src="AABLogo.png" className="mb-1 home-aablogo" style={{marginRight : 8}}/>
      <Container fluid style={{ width: '100%' }}className="mt-2 mb-2 d-flex align-items-start">                      
          <div>
            <p style={{ wordBreak: 'break-word' }} className="mb-1">
              BIDC Building 6, Harbour Industrial Estate, Bridgetown,
              Barbados, West Indies
            </p>
            <em>
              <p style={{ wordBreak: 'break-word' }} className="mb-0">  Tel: (246) 537-4684</p>
            </em>
            <em>
              <p style={{ wordBreak: 'break-word' }} className="mb-0">
                Email:{' '}
                <a href="mailto: info@athleticsassociationbb.com">
                  info@athleticsassociationbb.com
                </a>{' '}
                |{' '}
                <a href="mailto: bar@mf.worldathletics.org">
                  bar@mf.worldathletics.org
                </a>
              </p>
            </em>
            <em>
              <p style={{ wordBreak: 'break-word' }} className="mb-0">
                Website:{' '}
                <a href="http://aab.sports.bb">
                  http://aab.sports.bb/
                </a>
              </p>
            </em>
            <strong>
              <p style={{ wordBreak: 'break-word' }} className="mt-2">Affiliated to: World Athletics| NACAC Area Association | Barbados Olympic Association</p>
            </strong>
          </div>                      
        </Container>
        <img alt="AAB" src="pumalogo.png" className="mb-1 mr-2 ml-2 home-pumalogo" width={130} style={{marginLeft : 8}}/>
      </div>                
      <div className="border border-bottom" />
      <div style={{ width: '100%', flexWrap: 'wrap' }} className="d-flex  justify-content-center pt-2 mb-2">
        <h5 style={{ width: '100%', textAlign: 'center' }}>
          Select Type of Registration
        </h5>
        <Row md={8} className="d-flex justify-content-center">
          <Col>
          <Link to="/athlete-registration"><Button  
              onClick={() => {
                viewDispacth({ value: 'loading' });
                setTimeout(
                  () => viewDispacth({ value: 'athlete' }),
                  1000,
                );
              }}style={{ height: 80, width: 100 }} className="ml-auto mr-1">Athlete</Button></Link>
          </Col>
          <Col>
            <Link to="/coach-registration"><Button  
              onClick={() => {
                viewDispacth({ value: 'loading' });
                setTimeout(
                  () => viewDispacth({ value: 'coach' }),
                  1000,
                );
              }} style={{ height: 80, width: 100 }}  className="mr-auto">Coach</Button></Link>
          </Col>
        {
        TBD && 
        <Col>
            <Button
              style={{ height: 100, width: 150 }}
              className="mr-auto"
              onClick={() => {
                viewDispacth({ value: 'loading' });
                setTimeout(
                  () => viewDispacth({ value: 'affiliate' }),
                  1000,
                );
              }}
            >
              Affiliate / Clubs
            </Button>
          </Col>}
        </Row>
      </div>
      <div className="border border-bottom" />      
    </Container>
    )
  }
  return (
    <CoachDataDispatch.Provider value={{ coachDataDispacth, _coachDataState }}>
      <DataDispatch.Provider value={{ dataDispacth, _dataState }}>
        <ViewsDispatch.Provider value={viewDispacth}>
          <Container
            fluid
            className="d-flex flex-column align-items-center p-md-2"
            style={{ backgroundColor: '#0643d2', height: '100%' }}
          >
            <div  style={{ height: 75, width: '80%', backgroundColor: '#f3fa01' }}  className="app-section mr-auto ml-auto d-flex align-items-center pl-3">
              <h2 style={{ color: '#0643d2' }} className= "registration-header">
                {  
                    view === 'coach' ? 'AAB 2020-21 Coaches Registration Form' :
                    view === 'athlete' ? `AAB 2020-21 Athlete Registration Form` :
                    `AAB Registration Portal`
                  }
              </h2>
            </div>
            <div style={{ minHeight: 400, width: '80%', backgroundColor: 'white' }} className="app-section mr-auto ml-auto d-flex" >
              {
                view === 'loading' ?  <Loading /> :
                <Router>
                  <Switch>
                    <Route exact path="/athlete-registration"><Athlete/></Route>
                    <Route exact path="/coach-registration"><Coach/></Route>
                    <Route exact path="/"><LandingPage/></Route>
                  </Switch>
                </Router>
              }
            </div>
          </Container>
        </ViewsDispatch.Provider>
      </DataDispatch.Provider>
    </CoachDataDispatch.Provider>
  );
}
export { ViewsDispatch, DataDispatch, CoachDataDispatch };
export default App;
